import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgFacebook = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M5.81008 9.12764V14.6667H8.99143V9.12764H11.3637L11.8574 6.58077H8.99143V5.67973C8.99143 4.33337 9.54817 3.81775 10.9853 3.81775C11.4323 3.81775 11.7916 3.82817 12 3.849V1.5391C11.6078 1.43754 10.6479 1.33337 10.0939 1.33337C7.16215 1.33337 5.81008 2.64848 5.81008 5.48442V6.58077H4V9.12764H5.81008Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgFacebook)
const IconSvgFacebook = createIcon(ForwardRef, 'SvgFacebook')
export default IconSvgFacebook
